import script from "./NotifierCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifierCard.vue?vue&type=script&setup=true&lang=ts"

import "./NotifierCard.vue?vue&type=style&index=0&id=2c1e7026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1e7026"]])

export default __exports__